import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'landing-video',
  styleUrl: 'landing-video.css',
  shadow: false,
})
export class LandingVideo {
  @Prop() videoUrl: string = '';
  @Prop() thumbnail: string = '';

  render() {
    return <video-player fileUrl={this.videoUrl} thumbnail={this.thumbnail} />;
  }
}
